const VerticalDivider = function AddIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="18" viewBox="0 0 2 18" fill="none">
      <path d="M1.3457 1.38583V17.0985" stroke="#CACACA" stroke-width="1.17578" stroke-linecap="square" />
    </svg>
  );
};
export default VerticalDivider;
